import { ToastManagerRepository } from "@iot-platform/core";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";
import type { UserRepository } from "../repositories/user.repository";

@injectable()
export class UserDeleteUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(userId: number): Promise<boolean> {
        const result = await this.userRepository.delete(userId);

        if (result.isErr()) {
            const error = result.error.message;

            ToastManagerRepository.error(error);
        }

        return result.match(
            () => false,
            () => true,
        );
    }
}
